import Styles from './Rubric.scss';

import Template from './Rubric.hbs';
import TaskView from 'views/components/taskGroups/tasks/Task';
import SourceView from 'views/components/taskGroups/sources/Source';
import EvaluationRubric from 'views/components/evaluationRubric/EvaluationRubric.svelte';
import TimeUtil from 'util/TimeUtil';
import Button from 'views/components/button/Button.svelte';

export default class RubricActivity extends BaseView {

    show() {
        Backbone.View?.menubar?.setPreferredSize('small')
    }

    initialize({ activityShow }) {

        const taskGroupModel = this.model.task_groups.at(0);

        this.activityShow = activityShow

        let evalAt = false;

        if (this.model?.rubric?.evaluation?.updated_at) {
            evalAt = window.i18n.sprintf(
                'Evaluated at: %s',
                TimeUtil.getAbsoluteDate(this.model?.rubric?.evaluation?.updated_at)
            )
        }

        this.setElement(Template({
            Styles,
            evalAt,
            activityName: this.model.get('name')
        }));

        Backbone.View.header.clearButtons()
        Backbone.View.header.setTitle(this.model.get('name'))

        Backbone.View.header.setCrumblepath(
            taskGroupModel.getAllCrumblepathModels(),
            'show'
        )

        Backbone.View.header.setBackgroundImage(this.model)

        this.addElements(taskGroupModel);

        if (ACL.checkRole(ACL.roles.TEACHER)) {
            this.addSvelteChildView(
                '.js-evaluation-button',
                Button,
                {
                    label: window.i18n.gettext('Evaluate students'),
                    icon: 'progress',
                    theme: 'outlined',
                    callback: () => {
                        Backbone.history.navigate('/activities/progress/' + this.model.id, {trigger: true})
                    }
                }
            )
        }

        this.addSvelteChildView(
            '.js-evaluation-rubric',
            EvaluationRubric,
            {
                activity: this.model,
                readOnly: true,
                rubric: this.model.rubric,
                evaluation: ACL.checkRole(ACL.roles.STUDENT) && this.model.rubric?.evaluation
            }
        )

        if (Backbone.Model.user.get('is_student') && this.model?.rubric?.evaluation) {

            this.addSvelteChildView(
                '.js-evaluation-heading',
                Button,
                {
                    inline: true,
                    title: window.i18n.gettext('Print evaluation'),
                    icon: 'print',
                    theme: 'secondary',
                    callback: () => {
                        window.print();
                    }
                }
            );
        }
    }

    addElements(taskGroupModel) {

        for (const elementModel of taskGroupModel.elements.models) {

            let elementView;

            if (elementModel.get('element_type') === 'task') {

                elementView = new TaskView({
                    model: elementModel,
                    work_on: {
                        model: this.model,
                        activeItem: {
                            model: taskGroupModel
                        }
                    },
                    activityModel: this.model,
                })

                elementView.$('.js-title-sideline').remove();

            } else if (elementModel.get('element_type') === 'source') {

                elementView = new SourceView({
                    model: elementModel,
                    work_on: {
                        model: this.model,
                        activeItem: {
                            model: taskGroupModel
                        }
                    },
                    activityModel: this.model,
                })

            }

            if (elementView) {
                this.registerChildView(elementView)
                elementView.appendTo(this.$('.js-elements'));
            }
        }
    }

    /**
     * When this view is destroyed, unbind the navigation keys and remove the
     * is-work-on styling from the body.
     */
    onDestroy() {
        Backbone.View.menubar?.setPreferredSize()
        Backbone.View.header?.removeBackgroundImage()
    }
}
